import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type TradeInModuleSpecsFragment } from '../../../../api/fragments/TradeInModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

type TradeInModuleActionsProps = {
    module: TradeInModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const TradeInModuleActions = ({ module, permissions }: TradeInModuleActionsProps) => {
    const { t } = useTranslation(['tradeInModuleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = [
        hasDeletePermission && {
            label: t('tradeInModuleDetails:actions.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <Dropdown overlay={<Menu items={items} />}>
            <Button type="primary">
                <Space>
                    <span>{t('tradeInModuleDetails:actions.label')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default TradeInModuleActions;
